import type { MarketVariants } from '@/lib/i18n'

export type Slide3TwoStepsCopy = {
  title: string
  body: string
}

export const copy: MarketVariants<Slide3TwoStepsCopy> = {
  US: {
    title: 'The Power of the Pause',
    body:
      'It can be hard to resist the instinct to act when a situation feels urgent or emotionally charged. But stepping back - by hanging up, closing the message, or putting the phone down - gives your careful judgment time to catch up.',
  },
  ar: {
    title: 'قوة التوقّف',
    body:
      'قد يصعب مقاومة الرغبة في التصرّف فوراً حين يبدو الموقف عاجلاً أو مشحوناً عاطفياً. لكن التراجع خطوة إلى الوراء، بإغلاق الخط أو إغلاق الرسالة أو وضع الهاتف جانباً، يمنح تفكيرك المتأنّي الوقت الذي يحتاج إليه.',
  },
}
